import { render, staticRenderFns } from "./regBeauty.vue?vue&type=template&id=2d0d97e8&scoped=true&"
import script from "./regBeauty.vue?vue&type=script&lang=js&"
export * from "./regBeauty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d97e8",
  null
  
)

export default component.exports